<template>
	<div class="ui-deal">
		<div class="ui-deal-indicator-wrapper">
			<ui-tag-indicator v-if="idComputed" :radius="3" :text="String(idComputed)" :color="idColorComputed" />
		</div>

		<div class="ui-deal-title" v-if="titleComputed">{{ titleComputed }}</div>
		<div class="ui-deal-subtitle" v-if="subtitleComputed">{{ subtitleComputed }}</div>

		<div class="ui-deal-tag-line-wrapper" v-if="stageNameComputed || statusNameComputed">
			<ui-tag-line :radius="3" color="#cdd2db" :text="stageNameComputed" v-if="stageNameComputed" />
			<ui-tag-line :radius="3" color="#cdd2db" :text="statusNameComputed" v-if="statusNameComputed" />
		</div>
	</div>
</template>

<script>
	import { uiTagLine, uiTagIndicator } from '@/components/ui/tags'

	export default {
		components: {
			uiTagLine,
			uiTagIndicator,
		},

		props: {
			data: {
				type: Object,
				required: true,
				default: function () {
					return {}
				},
			},
		},

		computed: {
			titleComputed() {
				return this.data &&
					this.data.product_without_global_scopes &&
					this.data.product_without_global_scopes.name
					? this.data.product_without_global_scopes.name
					: null
			},

			subtitleComputed() {
				if (!this.data.unity) return null

				let info = 'Unidade '
				if (this.data.unity.number) info += `${this.data.unity.number} - `

				switch (this.data.unity.infos.typology) {
					case 'vertical':
						if (this.data.unity.infos && this.data.unity.infos.typology) {
							if (this.data.unity.floor == 0) info = `Térreo - `
							else info = `${this.data.unity.floor}º andar - `
							info += `${this.data.unity.infos.typology} - `
						}

						if (this.data.unity.block) info += `Torre ${this.data.unity.block} - `
						if (this.data.unity.garage) info += `Garagem - `
						if (this.data.unity.area) info += `${this.data.unity.area} m²`
						break

					default:
						if (this.data.unity.block) info += `Quadra ${this.data.unity.block} - `
						if (this.data.unity.infos.typology) info += `${this.data.unity.infos.typology} - `
						if (this.data.unity.garage) info += `Garagem - `
						if (this.data.unity.area) info += `${this.data.unity.area} m²`
						break
				}

				return info
			},

			idComputed() {
				return this.data && this.data.id ? this.data.id : null
			},

			idColorComputed() {
				return this.data && this.data.idle_color && this.data.idle_color.color
					? this.data.idle_color.color
					: null
			},

			stageNameComputed() {
				return this.data && this.data.stage && this.data.stage.name ? this.data.stage.name : null
			},

			statusNameComputed() {
				return this.data && this.data.status && this.data.status.name ? this.data.status.name : null
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
